import React from 'react';
import PropTypes from 'prop-types';

export const ButtonIcon = (props) => {

const style = {
	backgroundColor: `${ props.color }`,
	color: `${ props.textColor }`
}

	return (
		props.link ?
			<a className="btn btn--cta-kiwi btn-icon" href={props.link} style={ style } target="_blank">
				<span className="btn-label">{props.label}</span><span className="fa fa-arrow-right"></span>
			</a>
			:
			<button className="btn btn--cta-kiwi btn-icon" style={ style }>
				<span className="btn-label">{props.label}</span><span className="fa fa-arrow-right"></span>
			</button>
	)
};
	

ButtonIcon.propTypes = {
	label: PropTypes.string,
	link: PropTypes.string,
	color: PropTypes.string,
	textColor: PropTypes.string
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/ButtonIcon.js